import React from 'react'

const Loader = () => {
  return (
    <>
  <td className="spinner center bg-transparent ">
    <span  className='spinner-bottom'>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
    <span className="spinner-blade"></span>
   </span>
</td>
    </>
  )
}

export default Loader